import React from 'react'
import Nav from '../Nav'
import * as S from './styles'
import Brand from '../Brand'

const Header = () => {
  return (
    <S.Header data-testid="header">
      <Brand/>
      <Nav/>
    </S.Header>
  )
}

export default Header